import { useTranslate, HttpError } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import type { ReviewOut, ReviewUpdateIn } from '@/api/generated/schemas';

export const ReviewEdit = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps } = useForm<
    ReviewOut,
    HttpError,
    ReviewUpdateIn
  >({
    resource: 'feedback.reviews',
    mutationMeta: { method: 'patch' },
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          name="author_name"
          label={t('feedback.reviews.fields.author_name')}
        >
          <Input />
        </Form.Item>

        <Form.Item name="comment" label={t('feedback.reviews.fields.comment')}>
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
